import { Expose } from "class-transformer";
import { CreatePurchaseOrderLineDto } from "@/core/features/purchase-orders/create-purchase-order-line.dto";

export class UpdatePurchaseOrderLineDto extends CreatePurchaseOrderLineDto {
  @Expose()
  id?: string;
}
